var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49039 12.5962C1.89928 12.5962 2.23077 12.9276 2.23077 13.3365C2.23077 14.7535 2.23234 15.7418 2.3326 16.4875C2.42998 17.2119 2.60812 17.5954 2.88133 17.8687C3.15454 18.1419 3.53814 18.32 4.2625 18.4175C5.00817 18.5177 5.99645 18.5192 7.41346 18.5192H13.3365C14.7535 18.5192 15.7418 18.5177 16.4875 18.4175C17.2119 18.32 17.5954 18.1419 17.8687 17.8687C18.1419 17.5954 18.32 17.2119 18.4175 16.4875C18.5177 15.7418 18.5192 14.7535 18.5192 13.3365C18.5192 12.9276 18.8507 12.5962 19.2596 12.5962C19.6685 12.5962 20 12.9276 20 13.3365V13.3907C20 14.7408 20 15.829 19.885 16.6849C19.7655 17.5734 19.51 18.3215 18.9158 18.9157C18.3215 19.51 17.5734 19.7655 16.6849 19.885C15.829 20 14.7408 20 13.3907 20H7.3593C6.00924 20 4.92105 20 4.0652 19.885C3.17663 19.7655 2.42847 19.51 1.83427 18.9158C1.24007 18.3215 0.984495 17.5734 0.865027 16.6849C0.749961 15.829 0.749981 14.7408 0.750001 13.3907C0.750001 13.3727 0.750001 13.3546 0.750001 13.3365C0.750001 12.9276 1.08149 12.5962 1.49039 12.5962Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.375 15.0641C10.5829 15.0641 10.7811 14.9767 10.9214 14.8233L14.8701 10.5044C15.1461 10.2026 15.1251 9.73432 14.8233 9.4584C14.5216 9.18249 14.0532 9.20342 13.7773 9.5052L11.1154 12.4167V1.49038C11.1154 1.08148 10.7839 0.75 10.375 0.75C9.96613 0.75 9.63463 1.08148 9.63463 1.49038V12.4167L6.97273 9.5052C6.69682 9.20342 6.2285 9.18249 5.92672 9.4584C5.62494 9.73432 5.60396 10.2026 5.87987 10.5044L9.82861 14.8233C9.96889 14.9767 10.1671 15.0641 10.375 15.0641Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4dc14841d39c01bc4705b29495c1686f.svg";
export { ForwardRef as ReactComponent };